module.exports = __webpack_public_path__ + "static/media/copy.34cea283.svg";